module.exports = __webpack_public_path__ + "fce5c6bc00910e891336d062a99b443d.png";